<template>
	<div class="manage">
		<div class="top">
			<el-form :model="searchForm" :inline="true" @submit.native.prevent>
				<el-form-item>
					<el-input placeholder="请输入查询内容" v-model="searchForm.query" @keydown.enter.native.prevent="handleSearch"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleSearch">查询</el-button>
				</el-form-item>
			</el-form>
			<el-button type="primary" style="height:40px;" @click="handleUpFW" v-if="!$store.state.user.authAcc.includes($store.state.user.username)">升级固件</el-button>
		</div>

		<el-table :data="tableData" style="width: 100%"
			height="90%" :stripe="true" v-loading="loading">
			<el-table-column label="序号" prop="index" align="center" width="50"></el-table-column>
			<el-table-column label="数据库DID" prop="did" align="center" width="90"></el-table-column>
			<el-table-column label="串号" prop="serial_code" align="center" width="120"></el-table-column>
			<el-table-column label="IMEI" prop="IMEI" align="center" min-width="180"></el-table-column>
			<el-table-column label="ICCID" prop="ICCID" align="center" min-width="210"></el-table-column>
			<el-table-column label="IMSI" prop="IMSI" align="center" width="180"></el-table-column>
			<el-table-column label="注册时间" prop="register_time" align="center" width="168"></el-table-column>
			<el-table-column label="电量" prop="battery" align="center" width="60"></el-table-column>
			<el-table-column label="运动更新时间" prop="motion_time" align="center" width="168"></el-table-column>
			<el-table-column label="操作" align="center" width="120">
				<template slot-scope="scope">
					<el-button size="small" @click="handleClick(scope.row)">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="text-align:center">
			<el-pagination layout="sizes, prev, pager, next" 
			:total="pageTotal" 
			:page-sizes="[10, 20, 30, 40]"
			:page-size="pageSize" 
			:current-page.sync="currentPage" 
			@current-change="handleCurrentChange"
			@size-change="handleSizeChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		getDevices,
		searchDevice
	} from '../api'
	export default {
		data() {
			return {
				originData: [],
				tableData: [],
				searchForm: {
					query: ''
				},
				currentPage: this.$store.state.tab.currentBeltPage,
				pageSize: 20,
				pageTotal:1,
				loading: false
				
			};
		},
		mounted() {
			console.log('into belt vue')
			this.loading = true
			getDevices(1, this.pageSize).then((data) => {
				this.loading = false
				console.log("devices = ", data.data.data);
				this.tableData = data.data.data.devices;
				for (var i = 0; i < this.tableData.length; i++) {
					this.tableData[i]['index'] = i + 1;
				}
				this.originData = this.tableData;
				this.pageTotal=data.data.data.total
			});
		},
		methods: {
			handleCurrentChange(val) {
				console.log('val',val)
				getDevices(val, this.pageSize).then((data) => {
					console.log("devices = ", data.data.data);
					this.tableData = data.data.data.devices;
					for (var i = 0; i < this.tableData.length; i++) {
						this.tableData[i]['index'] = i + 1;
					}
					this.originData = this.tableData;
				});
				
				this.currentPage = val;
				this.$store.state.tab.currentBeltPage = val;
			},
			handleClick(row) {
				console.log(row);
				var infoUrl = '/beltinfo?did=' + row.did + '&sc=' + row.serial_code;
				console.log(infoUrl);
				this.$router.push(infoUrl);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.$store.state.tab.currentBeltPage = 1;
			},
			handleSearch() {
				var query = this.searchForm.query;
				console.log("query words:", this.searchForm.query);
				if (query == '')
					this.tableData = this.originData;
				else {
					this.loading = true
					this.tableData = [];
					searchDevice(query.toString()).then((data) => {
					console.log("查找结果 = ", data.data.data);
					this.tableData=data.data.data
					this.loading = false
				});
				}
			},
			handleUpFW() {
				console.log("跳转固件升级页面")
				this.$router.push('/beltupfw')
			}
		}
	}
</script>

<style lang="less" scoped>
	.manage {
		height: 90%;
	}

	.top {
		display: flex;
		justify-content: space-between;
	}
</style>